<app-data-set
	#dataSet
	[dataSource]="dataSource"
	defaultPresentationMode="table"
	firstColumnProperty="company.name"
	[rowId]="rowId"
>
	<app-data-set-toolbar>
		<div *appSearchActionGroup style="flex: 1">
			<app-data-set-search
				#dataSetSearch
				defaultFilterName="companyName"
				[defaultFilterLabel]="filterLabels.companyName"
				[placeholder]="filterLabels.defaultPlaceholder"
			>
				<div class="filter-grid" [style.--columns]="3">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.companyName }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('companyName')"
								(ngModelChange)="dataSet.filter('companyName', filterLabels.companyName, $event)"
								data-automation-id="company-name-input"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.contractName }}</mat-label>
							<input
								matInput
								[ngModel]="dataSet.filter('contractName')"
								class="contract-name-input"
								(ngModelChange)="dataSet.filter('contractName', filterLabels.contractName, $event)"
								data-automation-id="contract-name-input"
							/>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.status }}</mat-label>
							<mat-select
								[ngModel]="dataSet.filter('status')"
								(ngModelChange)="dataSet.filter('status', filterLabels.status, $event, contractStatusDropdownOptions)"
								data-automation-id="status-picker"
							>
								@for (option of contractStatusDropdownOptions; track option) {
									<mat-option [value]="option.value" [attr.data-automation-id]="'status-' + option.label">{{
										option.label
									}}</mat-option>
								}
							</mat-select>
						</mat-form-field>
					</div>
				</div>

				<div class="filter-grid" [style.--columns]="2">
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.billingStartDate }}</mat-label>
							<input
								data-automation-id="start-datepicker-input"
								matInput
								[matDatepicker]="picker"
								placeholder="{{ 'MM/DD/YYYY' | accessDatePlaceholderPipe }}"
								[ngModel]="dataSet.filter('billingStartDate')"
								(ngModelChange)="dataSet.filter('billingStartDate', filterLabels.billingStartDate, $event)"
							/>
							<mat-datepicker-toggle
								matSuffix
								class="date-picker-primary-blue"
								[for]="picker"
								data-automation-id="start-datepicker-toggle"
							></mat-datepicker-toggle>
							<mat-datepicker #picker data-automation-id="start-datepicker"></mat-datepicker>
						</mat-form-field>
					</div>
					<div class="filter-item">
						<mat-form-field subscriptSizing="dynamic" appearance="outline">
							<mat-label>{{ filterLabels.activeDate }}</mat-label>
							<input
								data-automation-id="active-date-input"
								matInput
								[matDatepicker]="activeDatePicker"
								placeholder="{{ 'MM/DD/YYYY' | accessDatePlaceholderPipe }}"
								[ngModel]="dataSet.filter('activeDate')"
								(ngModelChange)="dataSet.filter('activeDate', filterLabels.activeDate, $event)"
							/>
							<mat-datepicker-toggle
								matSuffix
								class="date-picker-primary-blue"
								[for]="activeDatePicker"
								data-automation-id="active-date-toggle"
							></mat-datepicker-toggle>
							<mat-datepicker #activeDatePicker data-automation-id="active-date-datepicker"></mat-datepicker>
						</mat-form-field>
					</div>
				</div>
			</app-data-set-search>
		</div>

		<ng-container>
			<div *appActionGroup>
				<app-data-set-action-button
					data-automation-id="add-billing-button"
					class="add-button"
					icon="add"
					label="Add"
					i18n-label="@@billingList-Add"
					(click)="onAddButtonClick()"
				></app-data-set-action-button>
			</div>
		</ng-container>
	</app-data-set-toolbar>

	<app-data-set-content>
		<app-data-set-table-view>
			@if (loadingService.isLoading(getBillingContractsLoadingKey) || !finishedLoadingInitData) {
				<app-data-set-loading-row />
			}
			<table
				mat-table
				[dataSource]="dataSource"
				matSort
				[hidden]="loadingService.isLoading(getBillingContractsLoadingKey) || !finishedLoadingInitData"
			>
				<tr class="mat-row" *matNoDataRow>
					<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@billingListTable-noRecordsFound">
						No records found.
					</td>
				</tr>

				<ng-container matColumnDef="companyName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@billingList-CompanyName">Company Name</th>
					<td mat-cell *matCellDef="let row">{{ row.company.name }}</td>
				</ng-container>

				<ng-container matColumnDef="contractName">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@billingList-ContractName">Contract Name</th>
					<td mat-cell *matCellDef="let row">{{ row.contractName }}</td>
				</ng-container>

				<ng-container matColumnDef="status">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@billingList-Status">Status</th>
					<td mat-cell *matCellDef="let row">
						<app-billing-status [status]="row.status"></app-billing-status>
					</td>
				</ng-container>

				<ng-container matColumnDef="billingStartDate">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@billingList-BillingStartDate">
						Billing Start Date
					</th>
					<td mat-cell *matCellDef="let row">{{ row.billingStartDate | accessDate }}</td>
				</ng-container>

				<ng-container matColumnDef="duration">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@billingList-Duration">Duration</th>
					<td mat-cell *matCellDef="let row">{{ row.duration }} <span i18n="@@billingList-Months">Months</span></td>
				</ng-container>

				<ng-container matColumnDef="rowMenu">
					<th mat-header-cell *matHeaderCellDef></th>
					<td mat-cell *matCellDef="let row">
						<ng-container>
							@if (row.status !== 'manuallyEnded' && row.status !== 'completed') {
								<app-data-set-table-menu [menu]="menu" [row]="row"></app-data-set-table-menu>
							}
						</ng-container>
					</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
				<tr
					mat-row
					*matRowDef="let row; columns: displayedColumns"
					(appDataSetRowClick)="onRowClick(row)"
					[attr.data-automation-id]="'billing-' + row.id + '-row'"
				></tr>
			</table>

			<mat-menu #menu="matMenu" class="hamburger-menu-container">
				<ng-template matMenuContent let-row="row">
					<button
						mat-menu-item
						i18n="@@billingList-Edit"
						(click)="onEditClick(row)"
						data-automation-id="billing-list-edit-button"
					>
						Edit
					</button>
					<button
						mat-menu-item
						i18n="@@billingList-EndBilling"
						(click)="onEndBillingClick(row)"
						data-automation-id="end-billing-button"
					>
						End Billing
					</button>
				</ng-template>
			</mat-menu>
		</app-data-set-table-view>
	</app-data-set-content>
</app-data-set>
